
import './StandardCallOut.scss';
import { StringHelper } from 'Utilities/StringHelper';


interface IStandardCallOutProps {
  id?: string;

  // Prefer these lower-case names since HTML attributes are lowercased by the DOM
  body?: string;
  image?: IGlassImage;
}

const StandardCallOut: React.FunctionComponent<IStandardCallOutProps> = (props) => {
  const hasBody = StringHelper.hasNonEmptyString(props.body);
  const body: string = props.body ?? '';
  const image = props.image;

  if (!hasBody) return null;

  return (
    <div id={props.id} className="standard-call-out">
      <div className="component-content">
        <div className="callout-flex-content">
          { image ? (
            <div className="call-out-image">
              <img
                src={image.Src}
                alt={image.Alt || image.Title || ''}
                title={image.Title || undefined}
                loading="lazy"
              />
            </div>
          ) : null}

          <div className={"rich-text callout-rich-text"} dangerouslySetInnerHTML={{ __html: body }}></div>
        </div>
      </div>
    </div>
  );
};

export default StandardCallOut;
